const mapArticles = (item: { link: string; title: string }[] = []) =>
  item.map((item) => ({
    title: item.title,
    url: item.link,
  }));

export { mapArticles };
